// API Configuration for Adrift Admin Dashboard
// This approach uses your backend API instead of direct Firebase connection

export const apiConfig = {
  // Your Firebase Functions API base URL
  // baseUrl: "http://localhost:5001/adriftchatbotv3/us-central1",  // Local development
  baseUrl: "https://us-central1-adriftchatbotv3.cloudfunctions.net", // Production
  
  endpoints: {
    ratings: "/admin/ratings",
    conversations: "/admin/conversations",
    aiData: "/admin/ai-data",
    analytics: "/admin/analytics",
    dailyReportConfig: "/getDailyReportConfig",
    saveDailyReportConfig: "/saveDailyReportConfig",
    testDailyReport: "/testDailyReport"
  }
};

/* 
SECURITY BENEFITS:
- No Firebase credentials exposed in browser
- Full admin access via service account
- Centralized authentication/authorization
- Better audit trail

TO USE THIS APPROACH:
1. Create admin API endpoints in your backend
2. Use service account for Firebase access
3. Admin dashboard calls your API instead
*/
